<template>
  <div>

    <form @submit.prevent="findClubs">
      <div class="form-group">
        <label for="min-level">Player level</label>
        <input
          type="number"
          id="min-level"
          v-model="minLevel"
          class="form-control"
          min="1"
          required
        >
      </div>
      <div class="form-group">
        <label for="lang-selector">Language</label>
        <b-form-select
          id="lang-selector"
          v-model="lang"
          :options="langOptions"
        />
      </div>

      <b-button type="submit" variant="primary">
        Find
      </b-button>
    </form>

    <loading-indicator
      v-if="isLoading"
    />

    <div v-show="foundClubs !== null" class="result">
      <h3>Search results</h3>

      <p v-show="resultMessage !== null">
        {{resultMessage}}
      </p>

      <table v-if="foundClubs !== null && foundClubs.length > 0" class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Min level</th>
            <th scope="col">Lang</th>
            <th scope="col">Country</th>
            <th scope="col">Members</th>
            <th scope="col">Active members</th>
          </tr>
        </thead>
        <tr
          v-for="club in foundClubs"
          :key="club.id"
        >
          <td>
            <club-link :clubId="club.id" />
          </td>
          <td>
            {{club.min_level}}
          </td>
          <td>
            {{club.lang | getLangNameEn}}
          </td>
          <td>
            {{club.country | getOptionalStringStr}}
          </td>
          <td>
            {{club.members}}
          </td>
          <td>
            {{club.active_member_amount}}
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import ClubLink from './ClubLink.vue';

import { LANG_UNKNOWN           } from '../util.js';
import { getOptionalLangOptions } from '../util.js';

export default {
  name: 'ActiveClubs',

  components: {
    LoadingIndicator,
    ClubLink,
  },

  data() {
    return {
      lang: LANG_UNKNOWN,
      langOptions: getOptionalLangOptions(),

      minLevel: 36,

      isLoading: false,

      foundClubs: null,
    };
  },

  computed: {
    resultMessage() {
      if(this.foundClubs !== null && this.foundClubs.length === 0) {
        return 'Clubs not found.';
      }
      return null;
    },
  },

  watch: {
    minLevel() {
      this.resetSearchResults();
    },
    lang() {
      this.resetSearchResults();
    },
  },

  created() {
    this.findClubs();
  },

  methods: {
    findClubs() {
      notifier.deleteSenderNotifications(this);
      this.isLoading = true;

      const url = '/clubs/active';
      HTTP.get(
        url,
        {
          params: {
            minLevel: this.minLevel,
            lang: this.lang,
          }
        }
      )
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.foundClubs = data;
      })
      .catch(error => {
        notifier.showError(error.response.data, {sender: this});
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    resetSearchResults() {
      this.foundClubs = null;
    },
  },
};
</script>

<style scoped>
.result {
  margin-top: 2rem;
}

.table {
  white-space: nowrap;
}
</style>
